// Mock data for Stefan Hay's freelancer website
export const mockData = {
  // Personal Information
  personalInfo: {
    name: "Stefan Hay",
    title: "Freelancer für Digitale Kommunikation, Social Media & Employer Branding",
    tagline: "Strategische Kommunikation für Unternehmen jeder Größe",
    description: "Ich helfe Unternehmen dabei, ihre digitale Präsenz zu stärken und authentische Arbeitgebermarken zu entwickeln. Von Start-ups bis zu Großkonzernen – gemeinsam entwickeln wir Kommunikationsstrategien und Haylights, die begeistern und verbinden.",
    image: "https://customer-assets.emergentagent.com/job_hay-comms-site/artifacts/fy8fzcbv_Screenshot%202025-07-18%20132114.jpg", // Stefan Hay Profilfoto
    secondaryImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop&crop=face", // Zweites Profilfoto
    linkedin: "https://www.linkedin.com/in/stefan-hay-de/",
    email: "stefan@haylights.de",
    phone: "",
    location: "Deutschland"
  },

  // Services
  services: [
    {
      id: 1,
      title: "Digitale Kommunikation",
      description: "Entwicklung und Umsetzung digitaler Kommunikations-strategien, die Ihre Zielgruppe erreichen und begeistern.",
      icon: "MessageCircle",
      features: [
        "Kommunikationsstrategie",
        "Digitale Kampagnen",
        "Foto- & Videoshootings",
        "Krisen-kommunikation",
        "Stakeholder-Management"
      ],
      color: "#8B5CF6"
    },
    {
      id: 2,
      title: "Social Media",
      description: "Professionelle Betreuung Ihrer Social Media Kanäle für maximale Reichweite und nachhaltigen digitalen Erfolg.",
      icon: "Share2",
      features: [
        "Social Media Strategie",
        "Content Creation & Kuration",
        "C-Level Positionierung",
        "Social Media Advertising",
        "Analytics & Reporting"
      ],
      color: "#0891B2"
    },
    {
      id: 3,
      title: "Employer Branding",
      description: "Aufbau einer starken Arbeitgeber-marke, die Top-Talente anzieht und Mitarbeitende langfristig erfolgreich bindet.",
      icon: "Users",
      features: [
        "Employer Brand Strategie",
        "Mitarbeitenden-Stories",
        "Recruiting-Kampagnen",
        "Unternehmens-kultur",
        "Talent Attraction"
      ],
      color: "#A855F7"
    }
  ],

  // Portfolio/Case Studies
  portfolio: [
    {
      id: 1,
      title: "Employer Branding Kampagne für Tech-Startup",
      client: "TechInnovate GmbH",
      category: "Employer Branding",
      description: "Entwicklung einer authentischen Arbeitgebermarke für ein schnell wachsendes Tech-Startup mit 50+ Mitarbeitern.",
      image: "https://images.unsplash.com/photo-1548094990-c16ca90f1f0d",
      results: [
        "150% Steigerung der Bewerbungen",
        "40% Reduktion der Fluktuation",
        "95% positive Mitarbeiterzufriedenheit"
      ],
      duration: "6 Monate",
      year: "2024"
    },
    {
      id: 2,
      title: "Social Media Relaunch für Mittelständler",
      client: "FamilienBetrieb AG",
      category: "Social Media",
      description: "Kompletter Relaunch der Social Media Präsenz eines traditionellen Familienunternehmens mit 200 Jahren Geschichte.",
      image: "https://images.unsplash.com/photo-1683721003111-070bcc053d8b",
      results: [
        "300% Reichweiten-Steigerung",
        "250% mehr Engagement",
        "80% jüngere Zielgruppe erreicht"
      ],
      duration: "4 Monate",
      year: "2024"
    },
    {
      id: 3,
      title: "Digitale Transformation Kommunikation",
      client: "GlobalCorp International",
      category: "Digitale Kommunikation",
      description: "Begleitung der digitalen Transformation eines Großkonzerns mit 5000+ Mitarbeitern weltweit.",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
      results: [
        "Erfolgreiche Change-Kommunikation",
        "90% Mitarbeiter-Akzeptanz",
        "Neue digitale Kommunikationskultur"
      ],
      duration: "12 Monate",
      year: "2023"
    }
  ],

  // Blog Posts
  blogPosts: [
    {
      id: 1,
      title: "Die Zukunft der Employer Branding: Authentizität schlägt Perfektion",
      excerpt: "Warum authentische Unternehmenskultur wichtiger ist als perfekte Kampagnen und wie Sie echte Arbeitgeberattraktivität schaffen.",
      date: "2024-01-15",
      readTime: "5 min",
      category: "Employer Branding",
      image: "https://images.unsplash.com/photo-1561070791-2526d30994b5",
      tags: ["Employer Branding", "Authentizität", "Unternehmenskultur"]
    },
    {
      id: 2,
      title: "Social Media Trends 2024: Was Unternehmen wissen müssen",
      excerpt: "Die wichtigsten Social Media Trends des Jahres und wie Sie diese für Ihr Unternehmen nutzen können.",
      date: "2024-01-10",
      readTime: "7 min",
      category: "Social Media",
      image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7",
      tags: ["Social Media", "Trends", "Marketing"]
    },
    {
      id: 3,
      title: "Krisenkommunikation in der digitalen Welt: Ein Leitfaden",
      excerpt: "Wie Sie in der digitalen Ära erfolgreich durch Krisen navigieren und das Vertrauen Ihrer Stakeholder bewahren.",
      date: "2024-01-05",
      readTime: "6 min",
      category: "Strategische Kommunikation",
      image: "https://images.pexels.com/photos/1034649/pexels-photo-1034649.jpeg",
      tags: ["Krisenkommunikation", "Strategie", "Digitale Kommunikation"]
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Dr. Sarah Weber",
      position: "CEO, TechInnovate GmbH",
      company: "TechInnovate GmbH",
      text: "Stefan hat unsere Employer Branding Strategie revolutioniert. Die Zusammenarbeit war professionell und die Ergebnisse übertreffen unsere Erwartungen bei weitem.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    {
      id: 2,
      name: "Michael Schmidt",
      position: "Marketing Director, FamilienBetrieb AG",
      company: "FamilienBetrieb AG",
      text: "Dank Stefan haben wir endlich eine moderne Social Media Präsenz, die unsere Tradition mit Innovation verbindet. Absolute Empfehlung!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
    },
    {
      id: 3,
      name: "Lisa Müller",
      position: "HR Director, GlobalCorp International",
      company: "GlobalCorp International",
      text: "Stefan begleitete uns durch eine komplexe digitale Transformation. Seine strategische Herangehensweise und Kommunikationskompetenz waren entscheidend für den Erfolg.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
    }
  ],

  // Contact Information
  contact: {
    email: "stefan@haylights.de",
    phone: "",
    location: "Deutschland",
    linkedin: "https://www.linkedin.com/in/stefan-hay-de/",
    availableFor: [
      "Langfristige Projekte",
      "Strategische Beratung",
      "Workshop-Moderation",
      "Interim-Management"
    ]
  }
};